<template>
  <loader watch="projects">
    <ul class="menu menu--projects">
      <ProjectsMenuItem
        v-for="project in projects"
        :key="project.code"
        :project="project"
        :is-superadmin="isSuperadmin"
        :is-admin="isAdmin"
      />
      <li v-if="isSuperadmin" class="menu__item menu__item--no-decor text-center pt-4">
        <b-button
          v-b-tooltip.hover
          :to="{ name: 'newProject' }"
          class="btn-icon-only"
          title="Add project"
          variant="rounded"
        >
          <Icon name="add" />
        </b-button>
      </li>
    </ul>
  </loader>
</template>

<script>
import { mapGetters } from 'vuex';
import UsersMethods from '@/components/mixins/users-methods';
import ProjectsMenuItem from '@/components/projects/projects-menu-item';

export default {
  name: 'ProjectsMenu',
  components: { ProjectsMenuItem },
  mixins: [UsersMethods],
  computed: mapGetters({
    projects: 'projects/projects'
  })
};
</script>
